export const isNullOrEmptyString = (v: string) => {
  return v == null || v.length === 0 || /^(\s)*$/.test(v);
};
